export class pageload {
 pageid:number;
 pagename : string;
 loadingtime : number;
 userid: number;
 Token:any;
}
